import gql from 'graphql-tag'
import { COMPANY_RECRUITER_FRAGMENT } from '@/components/Contacts/CompanyRecruiter/queries/CompanyRecruiters'

// Mutation used to create a brand-new company recruiter
export const CreateCompanyRecruiterMutation = gql`
  mutation CreateCompanyRecruiter($input: CreateCompanyRecruiterInput!) {
    createCompanyRecruiter(input: $input) {
      ...CompanyRecruiterFragment
    }
  }
  ${COMPANY_RECRUITER_FRAGMENT}
`
